'use strict';

var illustration = require('../../../../../../../../../../_virtual/illustration2.cjs');

var hasRequiredIllustration;

function requireIllustration () {
	if (hasRequiredIllustration) return illustration.__exports;
	hasRequiredIllustration = 1;

	const ILLUSTRATION_DIMENSIONS = {
	    small: 64,
	    medium: 88,
	    large: 104
	};

	illustration.__exports.ILLUSTRATION_DIMENSIONS = ILLUSTRATION_DIMENSIONS;
	
	return illustration.__exports;
}

exports.__require = requireIllustration;
//# sourceMappingURL=illustration.cjs.map
